import faMinusSquare from 'ksk/assets/template/faMinusSquare.svg';
import faPlusSquare from 'ksk/assets/template/faPlusSquare.svg';
import faMinusSquareRegular from 'ksk/assets/template/faMinusSquareRegular.svg';
import faPlusSquareRegular from 'ksk/assets/template/faPlusSquareRegular.svg';
import { px2em } from 'ksk/styledComponents/functions';
import { hoverActiveFocus } from 'ksk/styledComponents/mixins';
import { kskTheme, kskPalette, defaultThemeColor } from 'ksk/styledComponents/themes';
import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import Color from 'color';

const outerBorderColor = theme('mode', {
  padrao: 'transparent',
  altoContraste: 'white'
});

const boxBgColor = theme('mode', {
  padrao: 'white',
  altoContraste: 'black'
});

const topBorderColor = theme('mode', {
  padrao: () => kskTheme.themeColor,
  altoContraste: 'white'
});

const Section = styled.section`
  position: relative;
  width: 100%;
  background: ${boxBgColor};
  border-radius: ${kskTheme.borderRadius};
  border-style: solid;
  border-width: ${px2em(3)} ${px2em(1)} ${px2em(1)};
  border-color: ${topBorderColor} ${outerBorderColor} ${outerBorderColor} ${outerBorderColor};
  margin-bottom: ${px2em(20)};
  box-shadow: 0 ${px2em(1)} ${px2em(1)} rgba(0,0,0,.1);
  
  .ksk-box {
    border-width: ${px2em(1)} ${px2em(1)} ${px2em(1)} !important;
  }

  .ksk-box__header {
    color: #444;
    font-weight: 600;
    display: block;
    font-size: ${px2em(14)};
    line-height: 1;
    padding: ${px2em(10, 14)};
    position: relative;
    border-style: solid;

    border-color: ${kskTheme.lineColor};
    border-width: 0 0 ${px2em(1)} 0;

     /* // Avaliar depois devido ao crudEdit no mesmo box

     border-color: ${kskTheme.themeColor} ${kskTheme.lineColor} ${kskTheme.lineColor};
    border-width: ${px2em(2)} 0 ${px2em(1)} 0;

    &:first-child { 
      border-color: ${kskTheme.lineColor};
      border-width: 0 0 ${px2em(1)} 0;
    } */
  }

  .ksk-box__header.font-narrow {
    font-weight: normal !important;
  }

  &.ksk-collapse--control {
    .ksk-box__header {
      display: grid ;
      grid-template-rows: max-content;
      grid-template-columns: 1fr max-content;
    }
  }
  
  &.ksk-box--highlight {
    border-top: none;  
    .ksk-box__footer,    
    .ksk-box__header {
      border: none;
      background-position: center bottom;
      color: white;
      background-color: ${kskTheme.themeColor};  
    }

    .ksk-box__header {
      border-radius: ${kskTheme.borderRadius} ${kskTheme.borderRadius} 0 0;
    }
  }

  .ksk-box__body {
    padding: ${px2em(10)};
    border-radius: 0 0 ${kskTheme.borderRadius} ${kskTheme.borderRadius};

    &--with-error {
      border: 1px solid ${kskTheme.dangerColor};
    }
  }

  .ksk-box__body_no_pading_bottom{
    padding-bottom: ${px2em(0)};
  }

  .ksk-box__body_no_pading_top_bottom{
    padding-top: ${px2em(0)};
    padding-bottom: ${px2em(0)};
  }

  .ksk-box__footer {
    position: relative;
    top: ${px2em(-1)};
    border-top: ${px2em(1)} solid ${kskTheme.lineColor};
    padding: .75em;
    border-radius: 0 0 ${kskTheme.borderRadius} ${kskTheme.borderRadius};
  }

  .ksk-collapse {
     &--with-borders {
       border-top: 1px solid ${kskTheme.boldLineColor};

       .ksk-collapse__content {
         padding-bottom: 1.5em;
       }
     }
  }

  .ksk-collapse__buttons {
    display: flex;
    grid-gap: .2em;
  }

  .ksk-collapse__button { 

    //background: #f003;
    background: transparent;
    border: none;
    margin: -1.1em 0;
    padding: 0 0.33em 0 0;
    color: ${kskTheme.boldThemeColor};
    
    &--default {
      color: ${kskTheme.themeColor};
      display: flex;
      align-items: center;
    }
  }

  .ksk-collapse__button__icon {
    line-height: 0;
    display: inline-block;
    background: white;
    position: relative ;
    z-index: 0;
    

   /*  &::before {
      display: block;
      content: '';
      position: absolute;
      height: calc(100% - 3px);
      width: calc(100% - 2px);
      background: red;
      z-index: -1;
      top: 2px;
      left: 1px;
    } */


    &--with-drop-shadow {
      filter: 
        drop-shadow(0.071428571em 0px 0px white) 
        drop-shadow(0.071428571em 0.071428571em 0px ${kskTheme.boldThemeColor}) 
        drop-shadow(0.071428571em 0.071428571em 0px white) 
        drop-shadow(0.071428571em 0.071428571em 0px ${kskTheme.boldThemeColor});
    }

  }

  .ksk-collapse__button--default {
    height: 1.165em;
    width: 1.165em;
    position: relative;
    top:-.1em;
    background-color: #1351B4;
    mask-image:  url(${faPlusSquare});
    mask-repeat: no-repeat;
  }

  .ksk-collapse[open] > .ksk-collapse__summary > .ksk-collapse__button--default {
    mask-image:  url(${faMinusSquare});
  }


 /*  .ksk-collapse__button_plus {        
    left: .66em;
    height: 1.33em;
    width: 1.33em;
    background-color: hsl(164,32.8%,30.6%);
    display: inline-block;
    mask-image:  url(${faPlusSquareRegular});
    mask-repeat: no-repeat;
  }

  .ksk-collapse__button_minus {        
    left: .66em;
    height: 1.33em;
    width: 1.33em;
    background-color: hsl(164,32.8%,30.6%);
    display: inline-block;
    mask-image:  url(${faMinusSquareRegular});
    mask-repeat: no-repeat;
  } */

  .ksk-collapse__summary {
    list-style: none;
    //padding: .33em .33em .33em 2.33em;
    padding: .33em .66em;
    position: relative ;
    font-weight: 600;

    display: grid;
    grid-gap: .2em;
    align-items: center;

    grid-template-rows: max-content;
    grid-template-columns: max-content 1fr;

    background: #EAEEF4;
    // background: hsl(164,22.1%,90%);

    &--control {
      grid-template-columns: max-content 1fr max-content;
    }

    /* &::before {
      content: '';
      display: inline-block;
      position: absolute;
      left: .66em;
      height: 1.33em;
      width: 1.33em;
      background-color: hsl(164,32.8%,30.6%);
      mask-image:  url(${faPlusSquare});
      mask-repeat: no-repeat;
    }

    &--open::before {
      mask-image:  url(${faMinusSquare});    
      mask-repeat: no-repeat;
    }
 */

    ${hoverActiveFocus(css`
      background: #D9E3F3;
      // background: #91ADD9;
      /* background: ${Color(defaultThemeColor).lightness(95)}; */
      // background: #D9E1EF;
      // outline: 1px solid ${Color(defaultThemeColor).alpha(.2)};
    `)}
  }
`;

export const S = {
  Section
};
